import { render, staticRenderFns } from "./SalonHistory.vue?vue&type=template&id=23ee4886&scoped=true&"
import script from "./SalonHistory.vue?vue&type=script&lang=js&"
export * from "./SalonHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalonHistory.vue?vue&type=style&index=0&id=23ee4886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee4886",
  null
  
)

export default component.exports